/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import JSZip from 'jszip';
import download from 'js-file-download';
import {
  CustomGrid,
  CustomInfosForm,
  TextareaAutosize
} from '../../../../assets/style/globalStyle';
import palette from '../../../../@core/theme/palette';
import { validateCPF } from '../../../../@core/utils/utilsFunctions';
import { NotificationManager } from 'react-notifications';
import { DropzoneArea } from 'mui-file-dropzone';
import { useSelector } from 'react-redux';
import { selectLogin, selectClient } from '../../../../store/login/loginSlice';
import { isMobile } from 'react-device-detect';
import { useDebounce } from 'use-debounce';
import { useDispatch } from 'react-redux';
import {
  selectNotification,
  selectNotificationClient,
  client
} from '../../../../store/clients/clientsSlice';
import { formatDate, removeAccents } from '../../../../@core/utils/utilsFunctions';
import {
  Stack,
  Typography,
  Card,
  Button,
  TextField,
  Grid,
  Select,
  MenuItem,
  Autocomplete,
  InputLabel,
  InputAdornment,
  IconButton,
  Tab,
  Box,
  Alert
} from '@mui/material';
import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing,
  Selection
} from 'devextreme-react/data-grid';
import { startAndStop } from '../../../../store/loading/loadingSlice';
import configAxios from '../../../../services/configAxios';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import InputMask from 'react-input-mask';
import LockResetIcon from '@mui/icons-material/LockReset';
import Iconify from '../../../../@core/theme/Iconify';
import RenderPage from '../../../layouts/RenderPage';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import MoreMenuDocuments from '../../../components/multiplesComponents/MoreMenuDocuments';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import HistorySales from './HistorySales';
import DocumentsForSignature from '../signature/DocumentsForSignature';
import DownloadDocumentsSigning from '../signature/DownloadDocumentsSigning';
import AddEditAddress from './AddEditAddress';
import pallete from '../../../../@core/theme/palette';

/**
 * id_type_client === 1 - Físico
 * id_type_client === 2 - Júridico
 *
 */

const AddEditClients = (props) => {
  const navigation = useNavigate();
  const location = useLocation();
  const { state, pathname } = location;
  const pathNameSplice = pathname.split('/');
  const allowedPageSizes = [5, 10, 20, 30];
  const dispatch = useDispatch();
  const [infosClients, setInfosClients] = useState(state ? { ...state.infosEdit } : {});
  const [initialInfosClients] = useState(state ? { ...state.infosEdit } : {});
  const [infosDeps, setInfosDeps] = useState([]);
  const [infosAddress, setInfosAddress] = useState({});
  const [infosAdressEdit, setInfosAddressEdit] = useState({});
  const [infosDisabledStatusVenda] = useState([
    'Rejeitada',
    'Aguardando cliente',
    'Aguardando corretora',
    'Aguardando operadora',
    'Aguardando administradora',
    'Aprovada',
    'Negada'
  ]);
  const [infosPlans, setInfosPlans] = useState([]);
  const [infosTables, setInfosTables] = useState([]);
  const [infosTablesTemp, setInfosTablesTemp] = useState([]);
  const [infosWaitingPeriod, setInfosWaitingPeriod] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddress, setOpenModalAddress] = useState(false);
  const [openModalDiscussions, setOpenModalDiscussion] = useState(false);
  const [salesValue, setSalesValue] = useState(infosClients.valclient || '');
  const infoStateTemp = useSelector(selectLogin);
  const notification = useSelector(selectNotification);
  const selectNotificationsClient = useSelector(selectNotificationClient);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const infosClient = useSelector(selectClient);
  const [infoSelectVend, setInfoSelectVend] = useState([]);
  const [infosUploads, setInfosUploads] = useState([]);
  const [infosAssociations, setInfosAssociation] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const key = useRef('');
  const [value] = useDebounce(key.current, 1000);
  const keys = useRef(1);
  const [valueKeys] = useDebounce(keys.current, 1000);
  const [values, setValues] = useState('1');
  const [countSigningDocuments, setCountSigningDocuments] = useState(
    infosClients.id && infoState.id_type_user === 1 ? 1 : 0
  );
  const [openModalSendEmailDocuments, setOpenModalSendEmailDocuments] = useState(false);
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const [openModalIntegration, setOpenModalIntegration] = useState(false);
  const [resultIntegration, setResultIntegration] = useState([]);
  const [infosContract, setInfosContract] = useState([]);
  const [rowSelected, setRowSelected] = useState();
  const [rowsSelected, setRowsSelected] = useState([]);
  const company = useSelector(selectClient);

  useEffect(() => {
    if (state === null && pathNameSplice[2] === 'editClients') [navigation('/app/clients')];

    if (pathNameSplice[2] === 'addClients' && infoState.id_type_user !== 2)
      [navigation('/app/clients')];

    if (
      infosClients.statusvenda === 'Aguardando corretora' ||
      infosClients.statusvenda === 'Aguardando operadora' ||
      infosClients.statusvenda === 'Aguardando administradora' ||
      infosClients.statusvenda === 'Aprovada'
    ) {
      getInfosContract();
    }

    Promise.all([
      // getFilesUploads(),
    ]);
  }, [infosClients.id]);

  useEffect(() => {
    if (Object.keys(selectNotificationsClient).length) {
      setInfosClients({ ...selectNotificationsClient });
      dispatch(client({}));
      keys.current = Math.random();
    }
  }, [notification]);

  function getInfosClient() {
    configAxios
      .get(`/clients/getClientById/${infosClients.id}`)
      .then((response) => {
        let valuesSalesDeps = 0;
        if (Object.keys(infosDeps).length) {
          infosDeps.map((element) => {
            valuesSalesDeps += +element.valclient;
          });
        }

        setInfosClients({
          ...response.data,
          valueTotal: (Number(valuesSalesDeps) + Number(infosClients.valclient)).toFixed(2)
        });

        key.current = Math.random();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar as informações do cliente, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getInfosContract() {
    const router =
      infosClients.id_type_client === 1
        ? `/clients/getInfosSignaturePF/${infosClients.id}`
        : `/clients/getInfosSignaturePJ/${infosClients.id}/null/resp_jur`;

    await configAxios
      .get(router)
      .then((result) => {
        setInfosContract(result.data.health);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as informações, por favor, tente novamente!',
          'Atenção'
        );
      });
  }


  // function getFilesUploads() {
  //   if (infosClients.id) {
  //     configAxios
  //       .get(`/uploads/listUploads/${infosClients.id}`)
  //       .then((response) => {
  //         setInfosUploads(response.data);
  //       })
  //       .catch(() => {
  //         NotificationManager.error(
  //           'Tivemos dificuldades para buscar os uploads, tente novamente!',
  //           'Atenção'
  //         );
  //       });
  //   }
  // }

  function getAddress() {
    configAxios
      .get(`/address/listAddress/null/${infosClients.id}`)
      .then((response) => {
        setInfosAddress(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para buscar os endereços no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function AddAddressModal(id) {
    if (id) {
      const valuesEdit = infosAddress.filter((element) => element.id === id);
      setInfosAddressEdit(valuesEdit);
    }
    setOpenModalAddress(true);
  }

  function validCPF(event) {
    if (event.target.value) {
      const cpfIsValid = validateCPF(event.target.value);
      if (infosClients.id_type_client === 1) {
        if (!cpfIsValid) {
          NotificationManager.warning('CPF inválido, por favor verifique!', 'Atenção');
          setInfosClients({ ...infosClients, cpf_cnpj: '' });
          return;
        }
        setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
      } else {
        if (!cpfIsValid) {
          NotificationManager.warning('CPF inválido, por favor verifique!', 'Atenção');
          setInfosClients({ ...infosClients, cpf_cnpj_resp: '' });
          return;
        }
        setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
      }
    }
  }

  function selectedRow(event) {
    setRowSelected(event.selectedRowsData[0]);
  }

  function HandleInputChange(event, params = {}) {
    if (params.autocomplete) {
      if (event) {
        setInfosClients({ ...infosClients, label: event.label, id_orgao: event.id });
        return;
      }
      return;
    }
    if (params.plan) {
      if (event) {
        const infosTablesTemp = infosTables.filter(
          (element) => element.codplano === event.codplano
        );

        setInfosTablesTemp([]);
        infosTablesTemp.unshift({ id: '', label: '' });
        setInfosTablesTemp(infosTablesTemp);
        infosClients.labeltables = '';
        setSalesValue('');
        infosClients.codtab = '';

        setInfosClients({
          ...infosClients,
          labelplans: event.label,
          codplano: event.codplano
        });

        if (infosClients.id) {
          NotificationManager.warning(
            'Ao alterar o plano e salvar, os planos dos titulares e dependentes serão recalculados com base no novo plano/tabela!',
            'Atenção'
          );
        }
        return;
      }
      return;
    }
    if (params.table) {
      if (event) {
        setInfosClients({ ...infosClients, labeltables: event.label, codtab: event.codtab });
        setSalesValue('');
        if (infosClients.id) {
          NotificationManager.warning(
            'Ao alterar a tabela e salvar, os planos dos titulares e dependentes serão recalculados com base no novo plano/tabela!',
            'Atenção'
          );
        }
        return;
      }
      return;
    }
    if (params.cep) {
      setInfosClients({ ...infosClients, ...params.cep });
      return;
    }
    if (params.vend) {
      setInfosClients({ ...infosClients, labelvend: event.label, id_user: event.id });
      return;
    }

    if (params.waitingPeriod) {
      if (event) {
        setInfosClients({
          ...infosClients,
          labelcarencia: event.label,
          codcarencia: event.codcarencia
        });
        return;
      }
      return;
    }

    if (params.association) {
      if (event) {
        setInfosClients({
          ...infosClients,
          labelassociation: event.label,
          id_association: event.id_association
        });
        return;
      }
      return;
    }

    if (event.target.name === 'dtnascimento') {
      setSalesValue('');

      if (event.target.value > new Date()) {
        NotificationManager.warning('Data de nascimento inválida, verifique!', 'Atenção');
        return;
      }
    }

    if (event.target.name === 'titbenef') {
      delete infosClients.valclient;
      setSalesValue('');
    }

    if (event.target.name === 'tpcontrat_client') {
      infosClients.titbenef = '';

      if (event.target.value === '3-COLETIVO POR ADESAO') {
        if (infosClients.id_type_client !== 1) {
          NotificationManager.warning(
            'Só é possível vincular o tipo de contratação coletivo por adesão a clientes pessoa física!',
            'Atenção'
          );
          return;
        }
        infosClients.titbenef = 'S';

        setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
      } else {
        if (infosClients.id_type_client !== 1 && event.target.value === '1-INDIVIDUAL/FAMILIAR') {
          NotificationManager.warning(
            'Só é possível vincular o tipo de contratação invidual/familiar a clientes pessoa física!',
            'Atenção'
          );
          return;
        }

        if (infosClients.id_type_client === 1 && event.target.value === '2-COLETIVO EMPRESARIAL') {
          NotificationManager.warning(
            'Só é possível vincular o tipo de contratação coletivo empresarial a clientes pessoa jurídica!',
            'Atenção'
          );
          return;
        }

        if (event.target.name === 'email' || event.target.name === 'email_contato') {
          event.target.value = event.target.value.toLowerCase();
        }
        setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
      }
      return;
    }

    if (event.target.name === 'id_type_client') {
      infosClients.tpcontrat_client = '';
    }

    if (event.target.name === 'statusvenda') {
      if (event.target.value === 'Aguardando cliente') {
        if (
          infoState.tipointegracao !== 'Não possui' &&
          infosClients.statusvenda === infoState.statusintegracao
        ) {
          NotificationManager.warning('É necessário integrar a venda para prosseguir', 'Atenção');
          return;
        } else if (
          infoState.tipointegracao !== 'Não possui' &&
          infoState.controlacontrato === 'Sim' &&
          !infosClients.codcontrato
        ) {
          NotificationManager.warning('Por favor, preencha o código do contrato!', 'Atenção');
          return;
        }
      }
    }

    if (event.target.name === 'statusvenda' && infoState.id_type_user === 1) {
      if (!infosClients.senha) {
        NotificationManager.warning('Por favor, gere a senha!', 'Atenção');
        return;
      }
    }

    if (event.target.name === 'email' || event.target.name === 'email_contato') {
      event.target.value = event.target.value.toLowerCase();
    }

    setInfosClients({ ...infosClients, [event.target.name]: event.target.value });
  }

  function HandleSubmitDocument(event) {
    const formData = new FormData();

    if (event.length) {
      key.current = Math.random();

      for (let i = 0; i < event.length; i++) {
        formData.append(event[i].name, event[i], removeAccents(event[i].name));
      }

      if (infosClients.statusvenda === 'Aprovada') {
        NotificationManager.warning(
          'Não é possível realizar o upload de documentos em vendas aprovadas!',
          'Atenção'
        );
        return;
      }

      formData.append('infos', JSON.stringify(infosClients));

      configAxios
        .post('/uploads/createUploads', formData)
        .then(() => {
          // getFilesUploads();
          NotificationManager.success('Upload realizado com sucesso!', 'Sucesso');
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades para realizar o upload, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  /**
   * Foi feito dessa forma para submeter
   * somente as mudanças que de fato ocorreram no cadastro
   */
  function HandleSubmit(event) {
    event.preventDefault();
    const infosAddEdit = {
      ...infosClients
    };
    let infosEdit = {};

    if (infoState.id_type_user === 1) {
      if (infosClients.statusvenda === 'Aprovada') {
        NotificationManager.warning('Não é possível editar uma venda aprovada!', 'Atenção');
        return;
      }
    }

    if (infoState.id_type_user === 2) {
      if (infosClients.statusvenda !== 'Aberta') {
        NotificationManager.warning(
          'Não é possível editar uma venda que não esteja aberta!',
          'Atenção'
        );
        return;
      }
    }

    if (infosClients.statusvenda === 'Aguardando cliente' && countSigningDocuments > 0) {
      NotificationManager.warning(
        'Não é possível editar uma venda em que as assinaturas já tenham sido iniciadas!!',
        'Atenção'
      );
      return;
    }

    if (!salesValue && infosClients.titbenef == 'S' && infosClients.id_type_client !== 2) {
      NotificationManager.warning('Por favor, faça o cálculo do valor do beneficiário!', 'Atenção');
      return;
    }

    infosClients.id_user = infosClients.id_user ? infosClients.id_user : infoState.id;
    infosAddEdit.id_user = infosClients.id_user ? infosClients.id_user : infoState.id;

    if (!infosClients.id_user) {
      NotificationManager.warning('Por favor, selecione um vendedor', 'Atenção');
      return;
    }

    if (infoState.id_type_user === 2) {
      infosClients.aceitesmsemail = 'S';
    }
    const router = infosClients.id ? 'clients/updateClient' : 'clients/addClient';

    if (infosClients.id) {
      for (let key in infosAddEdit) {
        if (initialInfosClients[key] === infosAddEdit[key]) {
          if (key !== 'id' && key !== 'codclient' && key !== 'id_user') delete infosAddEdit[key];
        }
      }
    }

    if (infosClients.statusvenda === 'Negada') {
      for (let key in infosAddEdit) {
        if (
          key !== 'id' &&
          key !== 'codclient' &&
          key !== 'id_user' &&
          key !== 'motivo_negativa' &&
          key !== 'statusvenda'
        )
          delete infosAddEdit[key];
      }
    }

    configAxios
      .post(router, { infosAddEdit, infoState })
      .then((response) => {
        if (response.status === 201) {
          NotificationManager.warning(
            'O cliente foi cadastrado com sucesso, mas tivemos dificuldades para buscar o vendedor, tente novamente!',
            'Atenção'
          );
        }
        NotificationManager.success(
          infosClients.id ? 'Cliente atualizado com sucesso!' : 'Cadastro realizado com sucesso!',
          'Sucesso'
        );
        if (infosClients.id) {
          for (let key in infosAddEdit) {
            if (initialInfosClients[key] !== infosAddEdit[key]) {
              initialInfosClients[key] = infosAddEdit[key];
            }
          }

          setInfosClients({
            ...initialInfosClients,
            codclient: response.data.codclient,
            labelvend: response.data.labelvend ? response.data.labelvend : infosClients.labelvend,
            id: response.data.id,
            tpcontrat: response.data.tpcontrat
          });

          infosEdit = {
            ...initialInfosClients,
            codclient: response.data.codclient,
            id: infosClients.id ? infosClients.id : response.data.id,
            tpcontrat: response.data.tpcontrat
          };
        } else {
          setInfosClients({
            ...infosClients,
            codclient: response.data.codclient,
            labelvend: response.data.labelvend ? response.data.labelvend : infosClients.labelvend,
            id: response.data.id,
            tpcontrat: response.data.tpcontrat
          });

          infosEdit = {
            ...infosClients,
            codclient: response.data.codclient,
            id: infosClients.id ? infosClients.id : response.data.id,
            tpcontrat: response.data.tpcontrat
          };
        }

        key.current = Math.random();

        const nav = infosClients.id
          ? `/app/editClients/${infosClients.id}`
          : `/app/editClients/${response.data.id}`;
        navigation(nav, {
          state: { infosEdit }
        });
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function FormatDate(infos) {
    let dateFormated = formatDate(infos.data.data.datacadastro);
    return dateFormated;
  }

  // function ActionsButtons(items) {
  //   const infos = [];
  //   infos.push(items.data.data);
  //   return infos.map((item) => (
  //     <MoreMenu
  //       key={item.id}
  //       infos={{
  //         id: item.id,
  //         deleteRouter: '/clients/deleteClientDependent',
  //         deleteItem: infosClients.id_type_client === 1 ? 'o dependente' : 'o beneficiário',
  //         functionGrid: getDependents,
  //         statusvenda: infosClients.statusvenda
  //       }}
  //     />
  //   ));
  // }

  function ActionsButtonsUploads(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenuDocuments
        key={item.id}
        infos={{
          id: item.id,
          deleteRouter: '/uploads/deleteUploads',
          deleteItem: 'o documento',
          fileName: item.file,
          company: infosClient,
          id_type_client: infosClients.id_type_client,
          id_client: infosClients.id,
          statusvenda: infosClients.statusvenda
          // functionGrid: getFilesUploads
        }}
      />
    ));
  }

  function CalculeValuesClient() {
    if (!infosClients.dtnascimento) {
      NotificationManager.warning(
        'Por favor, preencha a data de nascimento para calcular!',
        'Atenção'
      );
      return;
    }
    if (!infosClients.codtab) {
      NotificationManager.warning('Por favor, escolha a tabela para calcular!', 'Atenção');
      return;
    }
    const infosSales = {
      codtab: infosClients.codtab,
      datanascimento: infosClients.dtnascimento
    };
    configAxios
      .post('utilsInfos/calculeSales', infosSales)
      .then((response) => {
        infosClients.valclient = response.data;
        setSalesValue(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para calcular o plano no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function GeneratePassword() {
    let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz!@#$%&*()_+';
    let string_length = 8;
    let randomstring = '';
    for (let i = 0; i < string_length; i++) {
      let rnum = Math.floor(Math.random() * chars.length);
      randomstring += chars.substring(rnum, rnum + 1);
    }

    const infosUpdate = {
      id: infosClients.id,
      senha: randomstring
    };

    configAxios
      .post('/clients/updatePassword', infosUpdate)
      .then(() => {
        NotificationManager.success('Senha gerada com sucesso!', 'Sucesso');
        setInfosClients({ ...infosClients, senha: randomstring });
        key.current = Math.random();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para gerar a senha, tente novamente!',
          'Atenção'
        );
      });
  }

  // function handleTabsChange(event, newValue) {
  //   setValues(newValue);
  // }

  // function ActionsButtonsAddress(items) {
  //   const infos = [];
  //   infos.push(items.data.data);
  //   return infos.map((item) => (
  //     <MoreMenu
  //       key={item.id}
  //       infos={{
  //         id: item.id,
  //         router: 'editClients',
  //         deleteRouter: '/address/deleteAddress',
  //         deleteItem: 'o endereço',
  //         functionGrid: getAddress,
  //         otherInfos: item,
  //         functionModal: AddAddressModal,
  //         statusvenda: infosClients.statusvenda
  //       }}
  //     />
  //   ));
  // }

  // function selectedRows(event) {
  //   setRowsSelected(event.selectedRowsData);
  // }

  // async function downloadFilesUploads() {
  //   const tpbenef = infosClients.id_type_client === 1 ? 'fisico' : 'juridico';
  //   const URL_AWS_S3 = 'https://mplansistemas-vendaonline.s3.sa-east-1.amazonaws.com';
  //   const zip = new JSZip();
  //   dispatch(startAndStop(true));

  //   for (let element of rowsSelected) {
  //     let url = `${URL_AWS_S3}/${company}/${tpbenef}/${infosClients.id}/${element.file}`;
  //     await fetch(url, {
  //       method: 'GET'
  //     })
  //       .then((res) => {
  //         return res.blob();
  //       })
  //       .then((blob) => {
  //         var file = new File([blob], element.file);
  //         zip.file(element.file, file, { base64: false });
  //       })
  //       .catch(() => {
  //         NotificationManager.error(
  //           'Tivemos dificuldades para gerar o download dos arquivos, tente novamente!',
  //           'Atenção'
  //         );
  //       });
  //   }

  //   dispatch(startAndStop(false));

  //   zip.generateAsync({ type: 'blob' }).then(function (content) {
  //     const zipblob = new Blob([content]);
  //     download(zipblob, `${infosClients.nome} - uploads.zip`);
  //   });
  // }

  return (
    <RenderPage title="Associados">
      <>
        {/* <AddEditAddress
          openModal={openModalAddress}
          otherInfos={infosClients}
          infosItemEdit={infosAdressEdit}
          countSigningDocuments={countSigningDocuments}
          setOpenModal={setOpenModalAddress}
          functionGrid={getAddress}
        /> */}

        <HistorySales
          openModal={openModalHistory}
          setOpenModal={setOpenModalHistory}
          infosClients={infosClients}
        // infosHistorySales={infosHistorySales}
        />
        {!isMobile && (
          <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
            <Grid container>
              <BreadcrumbsNav {...props} />
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Typography variant="h4" gutterBottom>
                  Cadastro do associado
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  Utilize as opções abaixo para visualizar os associados!
                </Typography>
              </Grid>
              <Alert
                severity={infosClients.status === 'Aguardando pagamento' ? 'warning' : 'success'}>
                Status do associado:{' '}
                {infosClients.status === 'Aguardando pagamento' ? 'Aguardando pagamento' : 'Ativo'}
              </Alert>
            </Grid>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/clients"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            </Stack>
          </Stack>
        )}

        <Card>
          <CustomGrid>
            <form onSubmit={HandleSubmit}>
              <Box
                sx={{
                  width: '100%',
                  border: 1,
                  borderColor: 'grey.200',
                  p: 2,
                  color: `${pallete.primary.contrastText}`
                }}>
                <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                <Grid container spacing={2} sx={{ mb: 0 }}>
                  {infosClients.id && (
                    <>
                      <Grid item xs={12} md={1} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                        <TextField
                          name="id"
                          fullWidth
                          label="ID"
                          variant="outlined"
                          size="small"
                          required
                          disabled
                          value={infosClients.id || ''}
                        />
                      </Grid>
                      {infosClients.codContrato && (
                        <>
                          <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                            <TextField
                              name="codContrato"
                              fullWidth
                              label="Código do cliente"
                              variant="outlined"
                              size="small"
                              required
                              disabled
                              value={infosClients.codContrato + '-' + infosClients.codUsuario || ''}
                            />
                          </Grid>

                          <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                            <TextField
                              name="codEmpresa"
                              fullWidth
                              label="Código da Empresa"
                              variant="outlined"
                              size="small"
                              required
                              disabled
                              value={infosClients.codEmpresa || ''}
                            />
                          </Grid>

                          <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                            <TextField
                              name="codigoPlano"
                              fullWidth
                              label="Código do Plano"
                              variant="outlined"
                              size="small"
                              required
                              disabled
                              value={infosClients.codigoPlano || '-'}
                            />
                          </Grid>

                          <Grid item xs={12} md={2} sx={isMobile ? { mt: 1 } : { mt: 4.2 }}>
                            <TextField
                              sx={{ input: { color: palette.primary.contrastText } }}
                              name="dtInicio"
                              label="Data da início"
                              fullWidth
                              type="date"
                              required
                              variant="outlined"
                              size="small"
                              disabled={true}
                              value={infosClients.dtInicio || ''}
                              onChange={(event) => HandleInputChange(event)}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </Grid>
                        </>
                      )}
                    </>
                  )}
                </Grid>

                <Grid container spacing={2} sx={{ color: `${pallete.primary.contrastText}` }}>
                  <Grid item xs={12} md={3} sx={isMobile ? {} : { mt: 2 }}>
                    <TextField
                      name="nomeUsuario"
                      fullWidth
                      label="Nome Associado(a)"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.nomeUsuario || ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={1.5} sx={isMobile ? { mt: 0 } : { mt: 2 }}>
                    <TextField
                      name="parentesco"
                      fullWidth
                      label="Parentesco"
                      variant="outlined"
                      size="small"
                      required
                      disabled
                      value={infosClients.parentesco || ''}
                    />
                  </Grid>
                  <Grid item xs={12} md={1.5} sx={isMobile ? { mt: 0 } : { mt: 2 }}>
                    <TextField
                      name="sexo"
                      fullWidth
                      label="Sexo"
                      variant="outlined"
                      size="small"
                      required
                      disabled
                      value={infosClients.sexo}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 2 }}>
                    <InputMask
                      sx={{ input: { color: palette.primary.contrastText } }}
                      mask="999.999.999-99"
                      value={infosClients.cpf || ''}
                      disabled={true}
                      onChange={(event) => HandleInputChange(event)}
                      onBlur={(event) => validCPF(event)}>
                      {() => (
                        <TextField
                          sx={{ input: { color: palette.primary.contrastText } }}
                          name="cpf"
                          fullWidth
                          label="CPF"
                          required
                          disabled={true}
                          variant="outlined"
                          size="small"
                        />
                      )}
                    </InputMask>
                  </Grid>

                  <Grid item xs={12} md={2} sx={isMobile ? { mt: 0 } : { mt: 2 }}>
                    <TextField
                      sx={{ input: { color: palette.primary.contrastText } }}
                      name="rg"
                      label="RG"
                      fullWidth
                      placeholder="Ex: 99.999.999-9"
                      required
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.rg || ''}
                      inputProps={{ maxLength: 20 }}
                      onChange={(event) => HandleInputChange(event)}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 1, input: { color: palette.primary.contrastText } }}>
                  <Grid item xs={12} md={2}>
                    <TextField
                      name="celular"
                      fullWidth
                      label="Celular"
                      variant="outlined"
                      size="small"
                      required
                      disabled
                      value={infosClients.celular || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      name="telefone"
                      fullWidth
                      label="Telefone"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.telefone || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      name="email"
                      fullWidth
                      label="E-mail"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.email || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 1, input: { color: palette.primary.contrastText } }}>

                  <Grid item xs={12} md={3}>
                    <TextField
                      name="endereco"
                      fullWidth
                      label="Endereço"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.endereco || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={1}>
                    <TextField
                      name="numres"
                      fullWidth
                      label="Num."
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.numres || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      name="complemento"
                      fullWidth
                      label="Complemento"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.complemento || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>



                  <Grid item xs={12} md={2}>
                    <TextField
                      name="bairro"
                      fullWidth
                      label="Bairro"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.bairro || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      name="cep"
                      fullWidth
                      label="CEP"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.cep || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      name="bairro"
                      fullWidth
                      label="Bairro"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.bairro || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <TextField
                      name="cidade"
                      fullWidth
                      label="Cidade"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.cidade || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>

                  <Grid item xs={12} md={1}>
                    <TextField
                      name="uf"
                      fullWidth
                      label="UF"
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosClients.uf || ''}
                      inputProps={{ maxLength: 100 }}
                      onChange={(event) => HandleInputChange(event)}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* {infosClients.id && (
                <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200' }}>
                  <TabContext value={values}>
                    <Box sx={{ mt: 1, p: 2 }}>
                      <TabList
                        onChange={handleTabsChange}
                        aria-label="ClientsTabs"
                        variant="scrollable"
                        scrollButtons="auto">
                        <Tab label="Endereços" value="1" />
                        <Tab
                          label={
                            infosClients.id_type_client === 1 ? 'Dependentes' : 'Beneficiários'
                          }
                          value="2"
                        />
                        <Tab label="Documentos/Uploads" value="3" />

                        {infosClients.statusvenda === 'Aguardando corretora' && (
                          <Tab label="Assinaturas" value="4" />
                        )}
                        {(infosClients.statusvenda === 'Aguardando operadora' ||
                          infosClients.statusvenda === 'Aprovada' ||
                          infosClients.statusvenda === 'Aguardando administradora') && (
                            <Tab label="Assinaturas" value="4" />
                          )}
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Stack direction="row" alignItems="center" justifyContent="end">
                        {!isMobile && (
                          <Grid container>
                            <Grid item>
                              <CustomInfosForm>Adicionar e/ou remover endereços</CustomInfosForm>
                            </Grid>
                          </Grid>
                        )}
                        {!isMobile && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1 }}>
                            <Button
                              variant="contained"
                              onClick={AddAddressModal}
                              startIcon={<Iconify icon="eva:plus-fill" />}>
                              Novo
                            </Button>
                            <Button
                              variant="outlined"
                              onClick={getAddress}
                              sx={{ ml: 1 }}
                              startIcon={<Iconify icon="eva:refresh-outline" />}>
                              Atualizar
                            </Button>
                          </Stack>
                        )}
                        {isMobile && (
                          <Grid item xs={12} sx={{ mb: 3 }}>
                            <Stack direction="row" alignItems="center" justifyContent="end">
                              <Button
                                variant="contained"
                                onClick={AddAddressModal}
                                startIcon={<Iconify icon="eva:plus-fill" />}>
                                Novo
                              </Button>
                            </Stack>
                          </Grid>
                        )}
                      </Stack>
                      <DataGrid
                        dataSource={infosAddress}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        noDataText={'Não foram encontrados endereços'}>
                        <Column dataField="rua" />
                        <Column dataField="numero" caption="Número" width={100} />
                        <Column dataField="bairro" />
                        <Column dataField="cidade" />
                        <Column dataField="estado" width={100} />
                        <Column dataField="cep" width={100} />
                        <Column dataField="desctype" caption="Tipo endereço" width={150} />
                        <Column
                          dataField="Ações"
                          width={100}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtonsAddress data={data} />}
                        />
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={5} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="2">
                      <Stack direction="row" alignItems="center" justifyContent="end">
                        {!isMobile && (
                          <Grid container>
                            <Grid item xs={12}>
                              {infosClients.id_type_client === 1 && (
                                <CustomInfosForm>
                                  Adicionar e/ou remover dependentes
                                </CustomInfosForm>
                              )}
                              {infosClients.id_type_client === 2 && (
                                <CustomInfosForm>
                                  Adicionar e/ou remover beneficiários
                                </CustomInfosForm>
                              )}
                            </Grid>
                          </Grid>
                        )}
                      </Stack>
                      <DataGrid
                        dataSource={infosDeps}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        noDataText={'Não foram encontrados beneficiários'}>
                        <Column dataField="id" caption="Id" />
                        <Column dataField="nome" />
                        <Column dataField="email" />
                        <Column dataField="cpf_cnpj" caption="Cpf" />
                        <Column dataField="tpbenef" caption="Tipo de beneficiário" />
                        <Column dataField="valclient" caption="Valor R$" />
                        <Column
                          dataField="datacadastro"
                          caption="Data de cadastro"
                          cellRender={(data) => <FormatDate data={data} />}
                        />
                     <Column
                          dataField="Ações"
                          width={100}
                          allowSorting={false}
                          cellRender={(data) => <ActionsButtons data={data} />}
                        /> 
                        <SearchPanel visible={true} width={253} placeholder="Procurar..." />
                        {!isMobile && (
                          <GroupPanel
                            visible={true}
                            emptyPanelText="Arraste as colunas aqui para agrupar"
                          />
                        )}
                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                        <Paging defaultPageSize={5} />
                        <Pager
                          visible={true}
                          allowedPageSizes={allowedPageSizes}
                          showPageSizeSelector={true}
                          showInfo={true}
                          showNavigationButtons={true}
                        />
                        <ColumnChooser
                          enabled={true}
                          title={'Escolher uma coluna'}
                          emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                        />
                        <ColumnFixing enabled={true} />
                        <HeaderFilter visible={true} allowSearch={true} />
                      </DataGrid>
                    </TabPanel>
                    <TabPanel value="3">
                      <Stack direction="row" alignItems="center" justifyContent="start">
                        {!isMobile && (
                          <Grid container>
                            <Grid item xs={12}>
                              <CustomInfosForm>
                                Adicionar, visualizar e/ou remover documentos
                              </CustomInfosForm>
                            </Grid>
                          </Grid>
                        )}
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ mb: 1 }}>
                          {!isMobile && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={downloadFilesUploads}
                                sx={{ mr: 1 }}
                                disabled={rowsSelected.length ? false : true}
                                startIcon={<Iconify icon="eva:cloud-download-outline" />}>
                                Download
                              </Button>
                              <Button
                                variant="outlined"
                                // onClick={getFilesUploads}
                                startIcon={<Iconify icon="eva:refresh-outline" />}>
                                Atualizar
                              </Button>
                            </>
                          )}
                        </Stack>
                      </Stack>
                      <DataGrid
                        dataSource={infosUploads}
                        showBorders={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnAutoWidth={true}
                        onSelectionChanged={selectedRows}
                        noDataText={'Não foram encontrados uploads'}>
                        <Selection mode="multiple" />

              <Column dataField="filename" caption="Nome do documento" />
              <Column dataField="dtope" caption="Data de operação" />
              <Column
                dataField="Ações"
                width={100}
                allowSorting={false}
                cellRender={(data) => <ActionsButtonsUploads data={data} />}
              />
              <SearchPanel visible={true} width={253} placeholder="Procurar..." />
              {!isMobile && (
                <GroupPanel
                  visible={true}
                  emptyPanelText="Arraste as colunas aqui para agrupar"
                />
              )}
              <Scrolling rowRenderingMode="virtual"></Scrolling>
              <Paging defaultPageSize={5} />
              <Pager
                visible={true}
                allowedPageSizes={allowedPageSizes}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />
              <ColumnChooser
                enabled={true}
                title={'Escolher uma coluna'}
                emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
              />
              <ColumnFixing enabled={true} />
              <HeaderFilter visible={true} allowSearch={true} />
            </DataGrid>
            <Grid container sx={{ mt: 1 }}>
              <DropzoneArea
                acceptedFiles={['image/*, application/pdf']}
                maxFileSize={10000000}
                onChange={(event) => HandleSubmitDocument(event)}
                dropzoneText="Arraste os arquivos aqui ou clique para selecionar"
                fullWidth={true}
                showAlerts={false}
                filesLimit={20}
                showPreviewsInDropzone={false}
                key={value}
                getFileLimitExceedMessage={(filesLimit) =>
                  NotificationManager.warning(
                    `Ultrapassou o limit de ${filesLimit} arquivos`,
                    'Atenção'
                  )
                }
                getDropRejectMessage={() => {
                  NotificationManager.warning(
                    `Ultrapassou o limite de 10mb, tente outro arquivo!`,
                    'Atenção'
                  );
                }}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="4">
            {isMobile && (
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="right"
                sx={{ mb: 2 }}>
                {infosClients.statusvenda === 'Aguardando corretora' &&
                  infoState.id_type_user === 2 &&
                  infoState.id_profile === 3 && (
                    <DocumentsForSignature
                      functionGrid={getInfosContract}
                      infosClients={infosClients}
                      getInfosClient={getInfosClient}
                      formClient={true}
                    />
                  )}
                {infosClients.statusvenda === 'Aguardando operadora' ||
                  (infosClients.statusvenda === 'Aguardando administradora' &&
                    infoState.id_type_user === 1 &&
                    infoState.id_profile !== 2 && (
                      <DocumentsForSignature
                        functionGrid={getInfosContract}
                        infosClients={infosClients}
                        getInfosClient={getInfosClient}
                        formClient={true}
                      />
                    ))}
                {infosClients.statusvenda === 'Aprovada' && (
                  <DownloadDocumentsSigning
                    infosClients={infosClients}
                    tipo={infosClients.tpcontrat_client}
                    key={value}
                    formClient={true}
                  />
                )}
              </Stack>
            )}
            {!isMobile && (
              <Stack direction="row" alignItems="center" justifyContent="start">
                <Grid container>
                  <Grid item xs={12}>
                    <CustomInfosForm>
                      Visualizar declarações de saúde e assinar documentos
                    </CustomInfosForm>
                  </Grid>
                </Grid>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="end"
                  sx={{ mb: 2 }}>
                  {infosClients.statusvenda === 'Aguardando corretora' &&
                    infoState.id_type_user === 2 &&
                    infoState.id_profile === 3 && (
                      <DocumentsForSignature
                        functionGrid={getInfosContract}
                        infosClients={infosClients}
                        getInfosClient={getInfosClient}
                        formClient={true}
                      />
                    )}
                  {(infosClients.statusvenda === 'Aguardando operadora' ||
                    infosClients.statusvenda === 'Aguardando administradora') &&
                    infoState.id_type_user === 1 &&
                    infoState.id_profile !== 2 && (
                      <DocumentsForSignature
                        functionGrid={getInfosContract}
                        infosClients={infosClients}
                        getInfosClient={getInfosClient}
                        formClient={true}
                      />
                    )}
                  {infosClients.statusvenda === 'Aprovada' && (
                    <DownloadDocumentsSigning
                      infosClients={infosClients}
                      tipo={infosClients.tpcontrat_client}
                      key={value}
                      formClient={true}
                    />
                  )}
                </Stack>
              </Stack>
            )}
            <DataGrid
              dataSource={infosContract}
              showBorders={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              onSelectionChanged={selectedRow}
              noDataText={'Não foram encontrados registros'}>
              <Selection mode="single" />
              <Column dataField="nome" caption="Nome" />
              <Column dataField="cpf_cnpj" caption="Cpf" />
              <Column dataField="tpbenef" caption="Tipo de beneficiário" />
              <Column dataField="email" caption="Email" />
              <SearchPanel visible={true} width={240} placeholder="Procurar..." />
              {!isMobile && (
                <GroupPanel
                  visible={true}
                  emptyPanelText="Arraste as colunas aqui para agrupar"
                />
              )}
              <Scrolling rowRenderingMode="virtual"></Scrolling>
              <Paging defaultPageSize={30} />
              <Pager
                visible={true}
                allowedPageSizes={allowedPageSizes}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />
              <ColumnChooser
                enabled={true}
                title={'Escolher uma coluna'}
                emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
              />
              <ColumnFixing enabled={true} />
              <HeaderFilter visible={true} allowSearch={true} />
            </DataGrid>
          </TabPanel>
        </TabContext>
              )} */}
              {/* </Box> */}

              <Stack direction="row" justifyContent="end" sx={{ mt: 5 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  color="success"
                  disabled={
                    (infoState.id_type_user === 2 && infosClients.statusvenda !== 'Aberta') ||
                      infosClients.statusvenda === 'Aprovada' ||
                      (infosClients.statusvenda !== 'Negada' && countSigningDocuments > 0)
                      ? true
                      : false
                  }
                  startIcon={<Iconify icon="eva:save-fill" />}
                  sx={{ mr: 2 }}>
                  {infosClients.id ? 'Atualizar' : 'Salvar'}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  component={RouterLink}
                  to="/app/clients"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </form>
          </CustomGrid >
        </Card >
      </>
    </RenderPage >
  );
};

export default AddEditClients;
